
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = {
    DevTool: () => null,
  };
} else {
  module.exports = require('./index.cjs.development.js')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@hookform/devtools/dist/index.js
// module id = 1370
// module chunks = 0